import lang from '../../lib/language';

export const SECTORS_PER_ROW = 3;
export const SECTORS_PER_ROW_MOBILE = 4;

/**
 * Headers for the five-column symbol table the Popular Groups, Gap Tracker and
 * 52-week screens share. Defined here because the two apps keep their own copy
 * under different filenames (`WatchList.constants` and `WatchList.constans`).
 */
export const SYMBOL_TABLE_HEADERS = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonChart(),
  lang.commonLastPriceShort(),
  lang.commonChange(),
  lang.commonPercentChange(),
];
